export default __webpack_public_path__ + "static/media/NavLogo_new.ae5b9147.png";